import type {
  FreelancerDetail,
  ApiOrganisationFreelancersDetailsListJobType,
} from 'state/__generated__/tadaahAPI';
import { useApiOrganisationFreelancersDetailsList } from 'state/__generated__/tadaahAPI';

type UseGetFreelancerDetailsType = {
  data: FreelancerDetail | undefined;
  error: string | undefined;
  isLoading: boolean;
};

const useGetFreelancerDetails = (
  freelancerId: string,
  jobId: string,
  jobType: ApiOrganisationFreelancersDetailsListJobType,
): UseGetFreelancerDetailsType => {
  const { data, error, isLoading } = useApiOrganisationFreelancersDetailsList(
    freelancerId.toString(),
    jobId.toString(),
    { job_type: jobType },
  );
  return { data: data?.data ?? undefined, error: error?.message, isLoading };
};

export default useGetFreelancerDetails;
